import request from '@/http/request'

export const getTunnelValidationResultData = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/tunnelValidationResult/list`, params)
}

export const getTunnelValidationResultDownload = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/tunnelValidationResult/export`,
    params,
    {
      responseType: 'blob',
      uploadOrDownload: true
    }
  )
}
